import { render } from "./PropertyAmalgamation.vue?vue&type=template&id=b58aadda&scoped=true"
import script from "./PropertyAmalgamation.vue?vue&type=script&lang=js"
export * from "./PropertyAmalgamation.vue?vue&type=script&lang=js"

import "./PropertyAmalgamation.vue?vue&type=style&index=0&id=b58aadda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58aadda"]])

export default __exports__